import PassportImage from './component'

export default PassportImage
